export default __webpack_public_path__ + "static/media/contact-wa.29b22a7b.svg";